import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import "react-toastify/dist/ReactToastify.css";
import { useState } from 'react';
import { commaSeparatedStringToArray } from "../../config/utils";
import { Accordion } from "react-bootstrap";
import DataTable from '../common/DataTable';
import { SKUTable } from '../../constant';
import _ from 'lodash';
import { getShippedLabelSummaryByOrderIds } from '../../store/actions/picker.action';
import { getmergePdfForPickingPdf, getPickListMergedPdf } from '../../store/actions/batch.action';
import { toast } from "react-toastify";
import LoaderSpinner from '../common/Loader';

/*istanbul ignore next */
const ViewOrderDialog = (props) => {
    const { modalClass, setModalShow, modalShow, viewDetailDetails, filterData, fetchAllList } = props;
    const [activeKeys, setActiveKeys] = useState([]);
    const [needsSeparation, setNeedsSeparation] = useState(true);
    const [checkedCount, setCheckedCount] = useState({
        seperationCount: 0,
        skuCount: 0,
        labelCount: 0
    });
    const [includePageIndex, setIncludePageIndex] = useState(false);
    const [allSelected, setAllSelected] = useState(false);
    const [showLoader, setShowLoader] = useState(false);

    const [skuDetails, setSkuDetails] = useState({
        multiSKUOrders: [],
        singleSKUMultipleQtyOrders: [],
        singleQtyOrders: []
    });

    useEffect(() => {
        getDetails();
    }, []);

    useEffect(() => {
        const allChecked =
            skuDetails.singleQtyOrders.every(item => item.isChecked) &&
            skuDetails.singleSKUMultipleQtyOrders.every(item => item.isChecked) &&
            skuDetails.multiSKUOrders.every(item => item.isChecked);

        setAllSelected(allChecked);
        checkedItemsCount();
    }, [skuDetails]);

    const checkedItemsCount = () => {
        const count =
            skuDetails.singleQtyOrders.filter(item => item.isChecked).length +
            skuDetails.singleSKUMultipleQtyOrders.filter(item => item.isChecked).length +
            skuDetails.multiSKUOrders.filter(item => item.isChecked).length;
        const labelCount =
            skuDetails.singleQtyOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.LabelCount, 0) +
            skuDetails.singleSKUMultipleQtyOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.LabelCount, 0) +
            skuDetails.multiSKUOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.LabelCount, 0);
        const skuCount =
            skuDetails.singleQtyOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.skuCount, 0) +
            skuDetails.singleSKUMultipleQtyOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.skuCount, 0) +
            skuDetails.multiSKUOrders.filter(item => item.isChecked).reduce((acc, item) => acc + item.skuCount, 0);
        setCheckedCount({
            seperationCount: count,
            skuCount: skuCount,
            labelCount: labelCount
        });
    }

    const hasSelectedItems = () => {
        return (
            skuDetails.singleQtyOrders.some(item => item.isChecked) ||
            skuDetails.singleSKUMultipleQtyOrders.some(item => item.isChecked) ||
            skuDetails.multiSKUOrders.some(item => item.isChecked)
        );
    };

    const toggleSelectAll = () => {
        const isSelecting = !allSelected;
        const updateChecked = (list) =>
            list.map((item) => ({ ...item, isChecked: isSelecting }));

        setSkuDetails({
            singleQtyOrders: updateChecked(skuDetails.singleQtyOrders),
            singleSKUMultipleQtyOrders: updateChecked(skuDetails.singleSKUMultipleQtyOrders),
            multiSKUOrders: updateChecked(skuDetails.multiSKUOrders),
        });

        if (isSelecting) {
            setActiveKeys(["0", "1", "2"]);
        }
        setAllSelected(isSelecting);
    };

    const handleAction = async (item, type) => {
        let data = commaSeparatedStringToArray(item.OrderNumber);
        let payload = {
            listOrderNumber: data,
            endDate: filterData.endDate,
            startDate: filterData.startDate,
            needsSeparation: false,
            isPrinted: true
        };
        if (data.length) {
            setShowLoader(true);
            let mergedRes = await getPickListMergedPdf(payload);
            if (mergedRes?.data?.Status === 200) {
                window.open(mergedRes.data.Entity);
                toast.success('Label printed successfully');
                getDetails();
                fetchAllList();
                setShowLoader(false);
            }
        } else {
            setShowLoader(false);
            toast.error('Can not reprint selected order(s) label');
        }
    };

    const handleSectionPrintAllAction = async (event, type) => {
        event.stopPropagation();
        const selectedOrders = [
            ...skuDetails.singleQtyOrders,
            ...skuDetails.singleSKUMultipleQtyOrders,
            ...skuDetails.multiSKUOrders
        ].filter(order => order.isChecked);

        if (!selectedOrders.length) {
            toast.error('No orders selected for printing');
            return;
        }

        const orderNumbers = selectedOrders.map(order => order.OrderNumber).join(',');
        const data = commaSeparatedStringToArray(orderNumbers);

        if (data.length) {
            handlePrintAction(data, type);
        } else {
            toast.error('Could not process selected orders');
            setShowLoader(false);
        }
    }

    const handlePrintAction = async (data, type) => {
        setShowLoader(true);
        if (type === 'printPicklist') {
            let payload = {
                listOrderNumber: data,
                endDate: filterData.endDate,
                startDate: filterData.startDate,
            };
            const mergedRes = await getmergePdfForPickingPdf(payload);
            if (mergedRes?.data?.Status === 200) {
                window.open(mergedRes.data.Entity);
                toast.success('Picklist Printed Successfully');
                getDetails();
                fetchAllList();
            }
        } else if (type === 'print') {
            let payload = {
                listOrderNumber: data,
                endDate: filterData.endDate,
                startDate: filterData.startDate,
                needsSeparation: needsSeparation,
                isPrinted: true,
                includePageIndex: includePageIndex
            };
            const mergedRes = await getPickListMergedPdf(payload);
            if (mergedRes?.data?.Status === 200) {
                window.open(mergedRes.data.Entity);
                toast.success('Label Printed Successfully');
                getDetails();
                fetchAllList();
            }
        }
        setShowLoader(false);
    }

    const handleCheckRecord = (e, type, name) => {
        const { checked } = e.target;
        let recordData = [...skuDetails[name]];
        if (_.isEmpty(type)) {
            if (checked) {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: true,
                }));
                setSkuDetails({
                    ...skuDetails,
                    [name]: markCheck
                });
            } else {
                let markCheck = recordData.map((item) => ({
                    ...item,
                    isChecked: false,
                }));
                setSkuDetails({
                    ...skuDetails,
                    [name]: markCheck
                });
            }
        } else {
            let skuDetailsObj = { ...skuDetails }
            let recordData = [...skuDetailsObj[name]];
            recordData[type.listIndex].isChecked = checked;
            setSkuDetails({
                ...skuDetails,
                [name]: recordData
            });
        }
    };

    const getDetails = async () => {
        let data = {
            ...viewDetailDetails.item,
            commaSeparatedIds: viewDetailDetails.item.orderNumber,
            startDate: filterData.startDate,
            endDate: filterData.endDate,
        }
        setShowLoader(true);
        let getRes = await getShippedLabelSummaryByOrderIds(data);
        if (getRes?.data?.Status === 200) {
            setShowLoader(false);
            if (!getRes?.data?.Entity.multiSKUOrders.length
                && !getRes?.data?.Entity.singleQtyOrders.length
                && !getRes?.data?.Entity.singleSKUMultipleQtyOrders.length) {
                setModalShow(false);
                return
            }
            let singleQtyOrdersIndex = getRes?.data?.Entity.singleQtyOrders.length && getRes?.data?.Entity.singleQtyOrders.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
                skuCount: Number(item.SKUCount)
            }));
            let singleSKUMultipleQtyOrdersIndex = getRes?.data?.Entity.singleSKUMultipleQtyOrders.length && getRes?.data?.Entity.singleSKUMultipleQtyOrders.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
                skuCount: Number(item.SKUCount)
            }));
            let multiSKUOrdersIndex = getRes?.data?.Entity.multiSKUOrders.length && getRes?.data?.Entity.multiSKUOrders.map((item, index) => ({
                ...item,
                listIndex: index,
                isChecked: false,
                skuCount: item.SKUCount.split(',').map(v => Number(v)).filter(n => !isNaN(n)).reduce((a, b) => a + b, 0) // NOSONAR
            }));
            setSkuDetails({
                multiSKUOrders: multiSKUOrdersIndex || [],
                singleSKUMultipleQtyOrders: singleSKUMultipleQtyOrdersIndex || [],
                singleQtyOrders: singleQtyOrdersIndex || []
            });
        }
    }

    const renderOrderSku = () => {
        const totalProductQuantity = skuDetails.multiSKUOrders.reduce((total, item) => {
            const sumPerRow = item.ProductQuantity
                .split(',')
                .map(Number)
                .reduce((a, b) => a + b, 0);

            return total + sumPerRow;
            }, 0);
        return totalProductQuantity;
    }

    return (
        <Modal
            className={modalClass || ''}
            size="lg"
            show={modalShow}
            onHide={() => setModalShow(false)}
        >
            <Modal.Header closeButton>
                <div className="modal-main-div viewOrder">
                    <span className="modal-m-text">Order Packing Plan </span>
                    <span className="modal-m-text mr-2">- {viewDetailDetails.item.companySellerName}</span>
                    {showLoader && <LoaderSpinner />}
                </div>
                <svg
                    className="btn-cclose close"
                    onClick={() => setModalShow(false)}
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    style={{ marginRight: "-520px" }}
                    cursor="pointer"
                >
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
                    <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg>
            </Modal.Header>
            <Modal.Body className={`${showLoader && 'disabled'}`}>
                <div className='flexDataTable'>
                    <button disabled={showLoader} className='btn cus-seconday-bg-btn mb-2' onClick={toggleSelectAll}>{allSelected ? 'Deselect All' : 'Select All'}</button>
                    <span>
                        <button disabled={!hasSelectedItems() || showLoader} className='btn cus-seconday-bg-btn mb-2' onClick={(event) => handleSectionPrintAllAction(event, 'print')}>Print Selected</button>
                        <button disabled={!hasSelectedItems() || showLoader} className='btn cus-seconday-bg-btn mb-2 ml-2' onClick={(event) => handleSectionPrintAllAction(event, 'printPicklist')}>Print Picklist</button>
                    </span>
                </div>
                <div className='displayFlexAndBetween fontFix mb-1 mt-2'>
                    <div className='displayFlexAndBetween'>
                        <div className='mr-2'>
                            <input type="checkbox" id="needsSeparation" checked={needsSeparation} onChange={() => setNeedsSeparation(!needsSeparation)} />
                            <label htmlFor="needsSeparation" className="ml-2">Apply Separation on Print {checkedCount.seperationCount > 0 && `(${checkedCount.seperationCount} Pages)`} </label>
                        </div>
                        <div>
                            <input type="checkbox" id="includePageDialog" checked={includePageIndex} onChange={() => setIncludePageIndex(!includePageIndex)} />
                            <label htmlFor="includePageDialog" className="ml-2">Print Index Page</label>
                        </div>
                    </div>
                    <div>
                        <div>Selected Label Count: {checkedCount.labelCount}</div>
                        Selected SKU Count: {checkedCount.skuCount}
                    </div>
                </div>

                <div className="incomingAccordion accordion">
                    <Accordion
                        activeKey={activeKeys}
                        onSelect={(keys) => setActiveKeys(keys)}
                        alwaysOpen
                    >
                        {skuDetails?.singleQtyOrders.length > 0 && (
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>
                                    <span>
                                        Single Qty <span className='subHeadingAccor'>(Total QTY (Ordered SKU) : {skuDetails.singleQtyOrders.reduce((acc, item) => acc + Number(item.ProductQuantity), 0)} Total Label Count: {skuDetails.singleQtyOrders.reduce((acc, item) => acc + item.LabelCount, 0)})</span> {" "}
                                    </span>
                                    <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="main_content_table_history">
                                        <div className="tableFixHeadListing pl-2 zIndex1">
                                            <DataTable
                                                headers={SKUTable}
                                                tableData={skuDetails.singleQtyOrders}
                                                tableDataStatus={showLoader}
                                                actionType={7}
                                                handleAction={handleAction}
                                                handleCheckRecord={handleCheckRecord}
                                                icon="print"
                                                name="singleQtyOrders"
                                                isSelectAll={skuDetails?.singleQtyOrders.filter(item => item.isChecked).length === skuDetails?.singleQtyOrders.length}
                                            />
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}

                        {skuDetails.singleSKUMultipleQtyOrders.length > 0 && (
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>
                                    <span>
                                        Single SKU Multiple Qty <span className='subHeadingAccor'>(Total QTY (Ordered SKU) : {skuDetails.singleSKUMultipleQtyOrders.reduce((acc, item) => acc + Number(item.ProductQuantity), 0)} Total Label Count: {skuDetails.singleSKUMultipleQtyOrders.reduce((acc, item) => acc + item.LabelCount, 0)})</span>
                                    </span>
                                    <div className='flexDataTable'>
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="main_content_table_history">
                                        <div className="tableFixHeadListing pl-2 zIndex1">
                                            <DataTable
                                                headers={SKUTable}
                                                tableDataStatus={showLoader}
                                                tableData={skuDetails.singleSKUMultipleQtyOrders}
                                                actionType={7}
                                                handleAction={handleAction}
                                                handleCheckRecord={handleCheckRecord}
                                                icon="print"
                                                name="singleSKUMultipleQtyOrders"
                                                isSelectAll={skuDetails?.singleSKUMultipleQtyOrders.filter(item => item.isChecked).length === skuDetails?.singleSKUMultipleQtyOrders.length}
                                            />
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                        {skuDetails.multiSKUOrders.length > 0 && (
                            <Accordion.Item eventKey="2">
                                <Accordion.Header>
                                    <span>
                                        Multi SKU Qty <span className='subHeadingAccor'>(Total QTY (Ordered SKU) : {renderOrderSku()} Total Label Count: {skuDetails.multiSKUOrders.reduce((acc, item) => acc + item.LabelCount, 0)})</span>
                                    </span>
                                    <div className='flexDataTable'>
                                        <i className="fa fa-chevron-down" aria-hidden="true"></i>
                                    </div>
                                </Accordion.Header>
                                <Accordion.Body>
                                    <div className="main_content_table_history">
                                        <div className="tableFixHeadListing pl-2 zIndex1">
                                            <DataTable
                                                headers={SKUTable}
                                                tableData={skuDetails.multiSKUOrders}
                                                actionType={7}
                                                handleAction={handleAction}
                                                handleCheckRecord={handleCheckRecord}
                                                icon="print"
                                                name="multiSKUOrders"
                                                tableDataStatus={showLoader}
                                                isSelectAll={skuDetails?.multiSKUOrders.filter(item => item.isChecked).length === skuDetails?.multiSKUOrders.length}
                                            />
                                        </div>
                                    </div>
                                </Accordion.Body>
                            </Accordion.Item>
                        )}
                    </Accordion>
                </div>
            </Modal.Body>

        </Modal>
    );
}

ViewOrderDialog.propTypes = {
    modalClass: PropTypes.string,
    setModalShow: PropTypes.func.isRequired,
    modalShow: PropTypes.bool.isRequired,
    viewDetailDetails: PropTypes.shape({
        item: PropTypes.shape({
            companySellerName: PropTypes.string,
            orderNumber: PropTypes.string,
            // Add other expected properties if known
        }).isRequired
    }).isRequired,
    filterData: PropTypes.shape({
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }).isRequired,
    fetchAllList: PropTypes.func.isRequired
};

export default ViewOrderDialog;